import { HiOutlineMail } from "react-icons/hi"
import { FaWhatsapp } from "react-icons/fa"
import { BiPhoneCall } from "react-icons/bi"


const data = [
    { id: 1, icon: <HiOutlineMail />, link: 'mailto:makindeyinkax@gmail.com' },
    { id: 2, icon: <FaWhatsapp />, link: 'https://wa.me/message/6B4YT7OK62YMM1' },
    { id: 3, icon: <BiPhoneCall />, link: "tel:07862849944" }

]


export default data;